import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isSofaSeatType } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { getLabelForLegendItem } from '../utils/get-label-for-legend-item';
import { SeatPickerLegendItemSeat } from './legend-item-seat';
import { SeatPickerLegendItemSofa } from './legend-item-sofa';
const b = bemClassBuilder('v-seat-picker-legend-item');
export const SeatPickerLegendItem = observer(({ legendItem }) => {
    const i18n = useI18n();
    return (_jsxs("li", { className: b.block(), children: [isSofaSeatType(legendItem.seatType) ? (_jsx(SeatPickerLegendItemSofa, { legendItem: legendItem })) : (_jsx(SeatPickerLegendItemSeat, { legendItem: legendItem })), _jsx("span", { className: b.element('label'), children: getLabelForLegendItem(legendItem, i18n) })] }));
});
SeatPickerLegendItem.displayName = 'SeatPickerLegendItem';
//# sourceMappingURL=legend-item.js.map